import { Coordinates } from './types';

export const DEFAULT_COORDS: Coordinates = {
  lat: 0,
  lng: 0,
};

export const DEBOUNCE_TIME_MS = 500;
